<template>
    <modal @modal-close="handleClose" size="half" tabindex="-1" role="dialog">
        <div class="bg-white rounded shadow-lg overflow-hidden pb-10 sm:pb-0">
            <div class="bg-light relative flex flex-wrap sm:items-end sm:justify-between py-6 px-8">
                <button @click="handleClose" type="button" class="absolute top-0 right-0 text-gray-600 hover:text-gray-700 mt-4 mr-6 py-1 px-2">
                    <i class="far fa-times fa-lg"></i>
                </button>

                <div class="text-center sm:text-left">
                    <h4 class="text-xl sm:text-2xl font-semibold mb-0">
                        <i class="fad fa-video mr-2"></i>
                        Video Content
                    </h4>

                    <h5 v-if="title" class="text-base text-muted mb-0 mt-2">
                        {{ title }}
                    </h5>
                </div>
            </div>

            <div class="p-8">
                <video-embed :src="sourceUrl" :params="settings" class="w-full" css="embed-responsive-16by9" />
            </div>
        </div>
    </modal>
</template>

<script>
/**
 * @see https://developers.google.com/youtube/player_parameters
 * @see https://github.com/nasa8x/v-video-embed
 */
export default {
    props: [
        'source-url',
        'title'
    ],

    data: () => ({
        settings: {
            autoplay: 1
        }
    }),

    created() {},

    mounted() {},

    computed: {},

    methods: {
        handleClose() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
